import { Routes, RouterModule } from '@angular/router';
import { UserManagementComponent } from './user-management/user-management.component';
import { LoginComponent } from './account/login/login.component';
import { ResetPasswordComponent } from '../app/account/reset-password/reset-password.component';
import { AuthguardService } from './common/services/authguard.service';
import { HomeComponent } from './home/home.component';
import { PayrollLogComponent } from './payroll-log/payroll-log.component'
import { ClientPayrollManagementComponent } from './client-payroll-management/client-payroll-management.component';
import { ClientManagementComponent } from '../app/client-management/client-management.component';
import { LogBookComponent } from './log-book/log-book.component'
import { ReportsComponent } from './reports/reports.component'

const appRoutes: Routes = [
    { path: '', redirectTo: '/home/client-payroll-management', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'resetpassword', canActivate: [AuthguardService], component: ResetPasswordComponent },
    { path: 'home', canActivate: [AuthguardService], component: HomeComponent,
        children: [
            { path: 'client-payroll-management', component: ClientPayrollManagementComponent},
            { path: 'user-management', canActivate: [AuthguardService], component: UserManagementComponent },
            { path: 'client-management', canActivate: [AuthguardService], component: ClientManagementComponent },
            { path: 'payroll-log', canActivate: [AuthguardService], component: PayrollLogComponent },
            { path: 'log-book', canActivate: [AuthguardService], component: LogBookComponent },
            { path: 'reports', canActivate: [AuthguardService], component: ReportsComponent}
        ]
    },
    // otherwise redirect to home
    { path: '**', redirectTo: 'client-payroll-management' }
];

export const appRouting = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts